import React from 'react';
import { Col, Row, Card, Typography, Button, ButtonGroup, Tag, Space, Popover } from '@douyinfe/semi-ui';
import { solutions } from './data/solutions';
import { FaInfoCircle, FaDownload, FaGooglePlay, FaAppStoreIos, FaExternalLinkAlt } from "react-icons/fa";
import { isEmpty } from 'lodash';

class SolutionsPage extends React.Component {
    constructor(props) {
        super(props);
    }

    renderRequirements(requirements) {
        if (!requirements) return null;

        const items = [];
        if (requirements.ios) {
            items.push(
                <li key="ios-min">iOS Minimum: {requirements.ios.minimum.os_version}, {requirements.ios.minimum.storage}, {requirements.ios.minimum.hardware}</li>,
                <li key="ios-rec">iOS Recommended: {requirements.ios.recommended.os_version}, {requirements.ios.recommended.storage}, {requirements.ios.recommended.hardware}</li>
            );
        }
        if (requirements.android) {
            items.push(
                <li key="android-min">Android Minimum: {requirements.android.minimum.os_version}, {requirements.android.minimum.storage}, {requirements.android.minimum.ram}</li>,
                <li key="android-rec">Android Recommended: {requirements.android.recommended.os_version}, {requirements.android.recommended.storage}, {requirements.android.recommended.ram}</li>
            );
        }
        if (requirements.server) {
            items.push(
                <li key="server-min">Minimum: {requirements.server.minimum.os}, {requirements.server.minimum.cpu}, {requirements.server.minimum.ram}, {requirements.server.minimum.storage}</li>,
                <li key="server-rec">Recommended: {requirements.server.recommended.os}, {requirements.server.recommended.cpu}, {requirements.server.recommended.ram}, {requirements.server.recommended.storage}</li>
            );
        }
        if (requirements.additional) {
            items.push(
                <li key="additional">Additional: {requirements.additional.internet}; {requirements.additional.notes}</li>
            );
        }

        return items.length > 0 ? (
            <Typography.Paragraph className="card-paragraph block">
                <strong>Requirements:</strong>
                <ul>{items}</ul>
            </Typography.Paragraph>
        ) : null;
    }

    render() {
        return (
            <div className="grid-container">
                <div className="page-header">
                    <Typography.Text className="page-title">Solutions</Typography.Text>
                </div>

                <Row 
                    type="flex" 
                    justify="center" 
                    gutter={[32, 32]} 
                    className="card-row"
                >
                    { !isEmpty(solutions) ?
                        solutions.map((item) => (
                            <Col 
                                xs={24} 
                                sm={12} 
                                md={12}
                                lg={12} 
                                key={item.id}
                                className="card-col"
                            >
                                <div className="card-content">
                                    <Card 
                                        title={
                                            <Typography.Text className="card-title-l">
                                                {item.icon}
                                                {item.name}
                                            </Typography.Text>
                                        }
                                        className="info-card"
                                        headerExtraContent={
                                            <ButtonGroup>
                                                {item.buttons.info.enable &&  
                                                    <Popover 
                                                        showArrow 
                                                        content={<span className="popover-content">{item.buttons.info.text}</span>} 
                                                        position="top"
                                                        className="popover-custom"
                                                    >
                                                        <Button 
                                                            icon={<FaInfoCircle size={18}/>} 
                                                            theme="borderless" 
                                                            className="button-social"
                                                        />
                                                    </Popover>
                                                }
                                                {item.buttons.download.enable && 
                                                    <Popover 
                                                        showArrow 
                                                        content={<span className="popover-content">Download</span>} 
                                                        position="top"
                                                        className="popover-custom"
                                                    >
                                                        <Button 
                                                            icon={<FaDownload size={18}/>} 
                                                            theme="borderless" 
                                                            className="button-social"
                                                            href={item.buttons.download.link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        />
                                                    </Popover>
                                                }
                                                {item.buttons.google_play.enable && 
                                                    <Popover 
                                                        showArrow 
                                                        content={<span className="popover-content">Google Play</span>} 
                                                        position="top"
                                                        className="popover-custom"
                                                    >
                                                        <Button 
                                                            icon={<FaGooglePlay size={18}/>} 
                                                            theme="borderless" 
                                                            className="button-social"
                                                            href={item.buttons.google_play.link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        />
                                                    </Popover>
                                                }
                                                {item.buttons.app_store.enable && 
                                                    <Popover 
                                                        showArrow 
                                                        content={<span className="popover-content">App Store</span>} 
                                                        position="top"
                                                        className="popover-custom"
                                                    >
                                                        <Button 
                                                            icon={<FaAppStoreIos size={18}/>} 
                                                            theme="borderless" 
                                                            className="button-social"
                                                            href={item.buttons.app_store.link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        />
                                                    </Popover>
                                                }
                                                {item.buttons.external_link.enable && 
                                                    <Popover 
                                                        showArrow 
                                                        content={<span className="popover-content">External Link</span>} 
                                                        position="top"
                                                        className="popover-custom"
                                                    >
                                                        <Button 
                                                            icon={<FaExternalLinkAlt size={18}/>} 
                                                            theme="borderless" 
                                                            className="button-social"
                                                            href={item.buttons.external_link.link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        />
                                                    </Popover>
                                                }
                                            </ButtonGroup>
                                        }
                                    >
                                        <div className="card-content-inner-solutions">
                                            <Typography.Paragraph className="card-description">
                                                <strong><b>Description:</b></strong> {item.description}
                                            </Typography.Paragraph>
                                            {item.category && 
                                                <Typography.Paragraph className="card-paragraph">
                                                    <strong>Category:</strong>
                                                    <Tag 
                                                        size="large" 
                                                        color='teal' 
                                                        type="solid" 
                                                        shape='circle' 
                                                        prefixIcon={item.category.icon}
                                                        className="tag-custom-no-border tag-teal"
                                                    >
                                                        {item.category.name}
                                                    </Tag>
                                                </Typography.Paragraph>
                                            }
                                            {!isEmpty(item.types) && 
                                                <Typography.Paragraph className="card-paragraph">
                                                    <strong>Type:</strong>
                                                    <Space wrap className="tag-custom-no-border">
                                                        {item.types.map((type, index) => (
                                                            <Tag 
                                                                key={index}
                                                                size="large" 
                                                                color='cyan' 
                                                                type="solid" 
                                                                shape='circle' 
                                                                prefixIcon={type.icon}
                                                                className="tag-custom-no-border tag-cyan"
                                                            >
                                                                {type.name}
                                                            </Tag>
                                                        ))}
                                                    </Space>
                                                </Typography.Paragraph>
                                            }
                                            {this.renderRequirements(item.requirements)}
                                        </div>
                                    </Card>
                                </div>
                            </Col>
                        )):
                        <div className="no-data">
                            No data available
                        </div>
                    }
                </Row>
            </div>
        );
    }
}

export default SolutionsPage;